import { Box, Flex } from 'components/Box'
import Container from 'components/layout/Container';
import styled from 'styled-components';

export const LoginBackgroundImage = styled(Flex)`
    background-repeat: no-repeat;
    background-size: cover;
    width: 100%;  
   
    ${({ theme }) => theme.mediaQueries.xs} {
        margin-bottom: 0px;
        background-image: none;
    }
    ${({ theme }) => theme.mediaQueries.sm} {
        background-image: url("./assets/banner/image_2021_12_31T09_34_28_192Z.png");
    }
`
export const LoginBackgroundFormBox = styled(Flex)`
    background: ${(props) => props.theme.colors.text};
    margin: auto;

    ${({ theme }) => theme.mediaQueries.xs} {
        height: 700px;
        border-radius: 20px 20px 0px 0px;
    }
    ${({ theme }) => theme.mediaQueries.sm} {
        width: 600px;
        height: 865px;
        border-radius: 20px;
    }
    ${({ theme }) => theme.mediaQueries.md} {
        height: 741px;
    } 
`

export const ContainerPaddingMargin = styled(Container)`
    
    ${({ theme }) => theme.mediaQueries.xs} {
        margin: 0;
        padding: 0;
        width: 100%;
    }
    ${({ theme }) => theme.mediaQueries.sm} {
        margin: auto;
        padding: 16px;
`

export const LoginFormStyle = styled(Box)`
    margin: auto;

    ${({ theme }) => theme.mediaQueries.xs} {
        width: 90%;
    }
    ${({ theme }) => theme.mediaQueries.sm} {
        width: 90%;
    }
`

export const InputFieldStyle = styled(Box)`
    margin-bottom:15px;
    
    & a{
        text-decoration:none;
        color: #001FFF;

        :hover{
            color:  ${(props) => props.theme.colors.primary};
        }

        ${({ theme }) => theme.mediaQueries.xs} {
            display: flex;
            justify-content: end;
        }
        ${({ theme }) => theme.mediaQueries.sm} {
            display: flex;
            justify-content: start;
        }
    }
    & input{
        border-radius: 12px;
        border: 2px solid ${(props) => props.theme.colors.primary};

        :focus{
            border: 2px solid ${(props) => props.theme.colors.imgBackgroundColor};
        }
    }
    & Button{
        width: 100%;
        height: 58px;
        background-color: ${(props) => props.theme.colors.imgBackgroundColor};
        font-size: ${'16px'};
        color: ${(props) => props.theme.colors.text};
        display: flex;
        justify-content: space-evenly;
    }
    & h3{
        text-align: center;
        padding: 40px 0px 10px 0px;
    }
    & img{
        width: 35px;
        height: 35px;
    }

    ${Flex}{
        ${({ theme }) => theme.mediaQueries.xs} {
        }
        ${({ theme }) => theme.mediaQueries.sm} {
            width:50%;
        }
    }
`

export const NeedAnAccount = styled(Flex)`
    margin: 20px 0px;    
    & a{
        color: #001FFF;
        text-decoration:none;
        margin-left:7px;

        :hover{
            color:  ${(props) => props.theme.colors.primary};
        }
    }

    ${({ theme }) => theme.mediaQueries.xs} {
        justify-content: center;
    }
    ${({ theme }) => theme.mediaQueries.sm} {
        justify-content: start;
    }
`

export const FormHeading = styled(Box)`
    text-align: center;
`
export const ModelWrapper = styled(Box)`
    text-align: center;

    & h2{
        font-weight: 800;
        font-size: 20px;
        margin-top: 20px;
    }
    & p{
        color: #A2A2A2;
        font-weight: 500;
        font-size: 16px;
    }
    & a{
        font-weight: 500;
        font-size: 16px;
        color: ${(props) => props.theme.colors.primary};
        text-decoration:none;
        margin: 20px 0px;
    }
`

export const TermsandConditions = styled(NeedAnAccount)`
    ${({ theme }) => theme.mediaQueries.xs} {
        justify-content: start;
    }
`